module.exports = __webpack_public_path__ + "static/media/ecology.137b9d75.jpg";